export default __webpack_public_path__ + "static/media/scanner-dark.62c8eae6.png";